import React, { Component, useState, useEffect } from "react";
import { styled, useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';

import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { TreeItem2 } from '@mui/x-tree-view';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { UserInfo, netGet, netPost } from "../network";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import EditIcon from '@mui/icons-material/Edit';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';

function AddMemberDialog(props) {
    const {
        title = 'Add Member to Role',
        open,
        onSave,
        onCancel,
        role,
        ...other
    } = props;

    const [memberValue, setMemberValue] = useState(null);
    const [userList, setUserList] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);

    useEffect(() => {
        if ( open && role) {
            netGet('/api/auth/users')
                .then(response => response.json())
                .then(users => {
                    if (Array.isArray(users)) {
                        setUserList(users);
                    }
                }).catch(error => {
                    console.log('Error fetching role list: ' + error);
                });
            
        } else {
            setUserList([]);
            setMemberValue(null);
        }
        
    }, [open, role]);


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                role: role,
                userId: memberValue.userId,
                givenName: memberValue.firstName,
                familyName: memberValue.lastName,
                email: memberValue.email,
                member: memberValue,
            });
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onMemberValueChanged = (event) => {
        setMemberValue(event.target.value);
        setOkEnabled(true);
    };


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: 700,
                    maxHeight: 600,
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{`${title} ${role}`}</DialogTitle>
            <DialogContent>

                <Box sx={{ paddingTop: '2ex' }}>
                    <FormControl size="small" sx={{ width: '100%' }}>
                        <InputLabel id="ace-add-role-label" size="small">User*</InputLabel>
                        <Select
                            labelId="ace-add-role-label"
                            id="ace-add-role-sel"
                            value={memberValue}
                            label="User*"
                            onChange={onMemberValueChanged}
                            size="small"
                            required
                        >
                            {Array.isArray(userList) &&
                                userList
                                    .sort( (a,b) => {
                                        let r = a?.firstName && b?.firstName ? a.firstName.localeCompare(b.firstName) : 0;
                                        if ( r === 0 ) {
                                            r = a?.lastName && b?.lastName ? a.lastName.localeCompare(b.lastName) : 0;
                                        }
                                        if ( r === 0 ) {
                                            r = a?.userId && b?.userId ? a.userId.localeCompare(b.userId) : 0;
                                        }
                                        return r;
                                    })
                                    .map((user, rindex) => (
                                    <MenuItem value={user} key={`role-add-member-${user.userId}-${rindex}`}>
                                        <Box sx={{display: 'flex'}}>
                                            <Typography >{`${user.firstName}\xa0${user.lastName}\xa0`}</Typography>
                                            <Typography sx={{fontStyle: 'italic'}}>{`(${user.userId})`}</Typography>
                                        </Box>
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: 3}}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function AddMultiMemberDialog(props) {
    const {
        title = 'Add Members to Role',
        open,
        onSave,
        onCancel,
        role,
        members,
        ...other
    } = props;

    const [selectedIds, setSelectedIds] = useState([]);
    const [membersValue, setMembersValue] = useState([]);
    const [userList, setUserList] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);

    useEffect(() => {
        setSelectedIds([]);
        if ( open && role ) {
            netGet('/api/auth/users')
                .then(response => response.json())
                .then(users => {
                    if (Array.isArray(users)) {
                        setUserList(users);
                    }
                }).catch(error => {
                    console.log('Error fetching role list: ' + error);
                });
            
        } else {
            setUserList([]);
        }
        if ( open && Array.isArray(members) ) {
            const sids = [];
            members.forEach( u => sids.push(u.userId));
            setMembersValue([...members]);
            setSelectedIds(sids);
        } else {
            setMembersValue([]);
            setSelectedIds([]);
        }
        
    }, [open, role, members]);

    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                role: role,
                members: membersValue,
            });
            
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };


    const handleListItemClick = (user) => {
        const sids = [...selectedIds];
        const mms = [...membersValue];
        if (selectedIds.includes(user.userId)) {
            const i = selectedIds.findIndex(uid => uid === user.userId);
            if (i >= 0) {
                sids.splice(i, 1);
                const m = membersValue.findIndex(me => me.userId === user.userId);
                if (m >= 0) {
                    mms.splice(m, 1);
                }
            }
        } else {
            const usr = userList.find(u => u.userId === user.userId);
            if (usr) {
                const member = { ...usr };
                if (usr.firstName) {
                    member.givenName = usr.firstName;
                }
                if (usr.lastName) {
                    member.familyName = usr.lastName;
                }
                mms.push(member);
                sids.push(user.userId);
            }
        }
        setSelectedIds(sids);
        setMembersValue(mms);
        setOkEnabled(true);
    };


    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 900,
                        maxHeight: 600,
                        minHeight: 600,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{`${title} ${role}`}</DialogTitle>
            <DialogContent>

                <Box sx={{ paddingTop: '2ex', overflow: 'auto', pl: 3 }}>
                    <List component="nav" aria-label="user list" >
                        {Array.isArray(userList) &&
                            userList
                                .sort((a, b) => {
                                    let r = a?.firstName && b?.firstName ? a.firstName.localeCompare(b.firstName) : 0;
                                    if (r === 0) {
                                        r = a?.lastName && b?.lastName ? a.lastName.localeCompare(b.lastName) : 0;
                                    }
                                    if (r === 0) {
                                        r = a?.userId && b?.userId ? a.userId.localeCompare(b.userId) : 0;
                                    }
                                    return r;
                                })
                                .map((user, rindex) => (
                                    <ListItem
                                        key={`UL0-${user.userId}`}
                                        secondaryAction={
                                            <Checkbox
                                                edge="end"
                                                onChange={() => handleListItemClick(user)}
                                                checked={selectedIds.includes(user.userId)}
                                                
                                            />
                                        }
                                        disablePadding
                                    >
                                        <ListItemButton
                                            selected={selectedIds.includes(user.userId)}
                                            onClick={() => handleListItemClick(user)}
                                            sx={{ padding: 0 }}
                                        >
                                            <ListItemText
                                                selected={selectedIds.includes(user.userId)}
                                                primary={
                                                    <Box sx={{ display: 'flex' }}>
                                                        <Typography >{`${user.firstName}\xa0${user.lastName}\xa0`}</Typography>
                                                        <Typography sx={{ fontStyle: 'italic' }}>{`(${user.userId})`}</Typography>
                                                    </Box>
                                                }
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))
                        }

                    </List>
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: 3}}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function RoleMemberDialogOld(props) {
    const {
        title = 'Role Configuration',
        open,
        onSave,
        onCancel,
        roles,
        memberMap,
        docId,
        ...other
    } = props;

    const [memberValue, setMemberValue] = useState(null);
    const [userList, setUserList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [roleMap, setRoleMap] = useState({});
    const [roleMemberMap, setRoleMemberMap] = useState({});
    const [addedRoleMembers, setAddedRoleMembers] = useState({});
    const [deletedRoleMembers, setDeletedRoleMembers] = useState({});
    const [roleModList, setRoleModList] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);
    const [addMemberOpen, setAddMemberOpen] = useState(false);
    const [addRoleOpen, setAddRoleOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState('');
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState('ALL');
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [contextMenu, setContextMenu] = useState(null);
    const [addMemberEnabled, setAddMemberEnabled] = useState(false);
    const [deleteEnabled, setDeleteEnabled] = useState(false);

    const theme = useTheme();

    useEffect(() => {
        if ( open) {
            setSelectedItemId('');
            setSelectedRole(null);
            setRoleModList([]);
            setAddedRoleMembers({});
            setDeletedRoleMembers({});
            if ( memberMap ) {
                setRoleMemberMap(memberMap);
            } else {
                setRoleMemberMap({});
            }
            if ( docId ) {
                if ( docId === 'NONE' ) {
                    setSelectedDocId('ALL');
                } else {
                    setSelectedDocId(docId);
                }
                loadRoles(docId);
            } else {
                setSelectedDocId('ALL');
                loadRoles();
            }
            netGet('/api/auth/users')
                .then(response => response.json())
                .then(users => {
                    if (Array.isArray(users)) {
                        setUserList(users);
                    }
                }).catch(error => {
                    console.log('Error fetching user list: ' + error);
                });
            
        } else {
            setUserList([]);
            setMemberValue(null);
            setSelectedDocId('ALL');
            setSelectedDoc(null);
            setRoleModList([]);
            setAddedRoleMembers({});
            setDeletedRoleMembers({});
            setRoleMemberMap({});
        }
        
    }, [open, docId, memberMap]);

    const loadRoles = (docName) => {
        setRoleMap({});
        netGet('/api/auth/aroles?g=0&v=1')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    // console.log('roles: ' + JSON.stringify(data));

                    setRoleList(data);
                    const rm = {};
                    data.forEach(r => {
                        rm[r.name] = r;
                    });
                    setRoleMap(rm);
                } else {
                    setRoleList([]);
                    setRoleMap({});

                }
            }).catch(error => {
                console.log('Error: ' + error);
                setRoleList([]);
                setRoleMap({});
            });
    }

    const handleRowClick = (index, entry) => {
        setSelectedIndex(index);
        setSelectedMember(entry);
        if ( index >= 0 ) {
            setDeleteEnabled(true);

        } else {
            setDeleteEnabled(false);
        }
        
    };

    const handleContextMenu = (event, index, entry) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
        if ( index >= 0 ) {
            handleRowClick(index,entry);
        }
    };

    const handleContextMenuClose = (event) => {
        setContextMenu(null);
    };

    const handleItemClick = (event, itemId) => {
        setSelectedItemId(itemId);
        const item = roleMap[itemId];
        setSelectedItem(item);
        setSelectedRole(null);
        setSelectedIndex(-1);
        setDeleteEnabled(false);
        // setSelectedDocId('');
        // setSelectedDoc(null);
        // setDeleteRoleEnabled(true);
        setAddMemberEnabled(true);
        /*
        if ( item?.type === 'G') {
            setAddMemberEnabled(true);
        } else {
            setAddMemberEnabled(false);
        }
        */
        const rmm = {...roleMemberMap};
        const odata = rmm[itemId];
        setSelectedRole(itemId);
        if (!Array.isArray(odata)) {

            netGet('/api/auth/members?role=' + encodeURIComponent(itemId) + '&doc=' + encodeURIComponent(selectedDocId))
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('Members: ' + itemId + ' = ' + JSON.stringify(data))

                        rmm[itemId] = data;
                        setRoleMemberMap(rmm);
                        setSelectedRole(itemId);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                });
        }
    };

    const handleMemberAdd = () => {
        handleContextMenuClose();
        setAddMemberOpen(true);
    }

    const onAddMemberSave = (entry) => {
        handleContextMenuClose();
        setAddMemberOpen(false); 
        const userId = entry.userId;
        const added = {...addedRoleMembers};
        let alist = added[entry.role];
        let mod = false;
        if ( !Array.isArray(alist) ) {
            alist = [];
        }
        if ( !alist.includes(userId) ) {
            alist.push(userId);
            added[entry.role] = alist;
            setAddedRoleMembers(added);
            mod = true;
        }
        const removed = {...deletedRoleMembers};
        const rlist = removed[entry.role];
        if ( Array.isArray(rlist) ) {
            const r = rlist.findIndex( r => r === userId);
            if ( r >= 0 ) {
                rlist.splice(r, 1);
                removed[entry.role] = rlist;
                setDeletedRoleMembers(removed);
            }
        }
        if ( mod && !roleModList.includes(entry.role)) {
            const rml = [...roleModList];
            rml.push(entry.role);
            setRoleModList(rml);
        }
        const rmm = {...roleMemberMap};
        const rmlist = rmm[entry.role];
        if (Array.isArray(rmlist)) {
            const au = rmlist.find(u => u.userId === userId);
            if (!au) {
                const user = userList.find( u => u.userId === userId);
                if ( user ) {
                    rmlist.push(user);
                    rmm[entry.role] = rmlist;
                    setRoleMemberMap(rmm);
                }
            }
        }
        setOkEnabled(true);
        /*
        netPost('/api/auth/member', {role: entry.role, userId: entry.userId, docId: selectedDocId})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } 
                    
                   setOkEnabled(true);
                   handleItemClick(null, selectedItemId);
                    return response.json();
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
        */
    };

    const handleMemberRemove = () => {
        handleContextMenuClose();
        const userId = selectedMember?.userId;
        const added = {...addedRoleMembers};
        const alist = added[selectedItemId];
        let mod = false;
        if ( alist ) {
            const m = alist.findIndex( r => r === userId);
            if ( m >= 0 ) {
                alist.splice(m, 1);
                added[selectedItemId] = alist;
                setAddedRoleMembers(added);
            }
        }
        const removed = {...deletedRoleMembers};
        let rlist = removed[selectedItemId];
        if ( !Array.isArray(rlist) ) {
            rlist = [];
        }
        if ( !rlist.includes(userId) ) {
            rlist.push(userId);
            removed[selectedItemId] = rlist;
            setDeletedRoleMembers(removed);
            mod = true;
        }
        if ( mod && !roleModList.includes(selectedItemId)) {
            const rml = [...roleModList];
            rml.push(selectedItemId);
            setRoleModList(rml);
        }
        const rmm = { ...roleMemberMap };
        const rmlist = rmm[selectedItemId];
        if (Array.isArray(rmlist)) {
            const r = rmlist.findIndex(u => u.userId === userId);
            if (r >= 0) {
                rmlist.splice(r, 1);
                rmm[selectedItemId] = rmlist;
                setRoleMemberMap(rmm);
            }
        }
        setOkEnabled(true);
        /*
        netPost('/api/auth/delmember', {role: selectedItemId, userId: selectedMember?.userId, docId: selectedDocId})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } 
                   setOkEnabled(true);
                   handleItemClick(null, selectedItemId);
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
        */
    }

    const addMembers = (data, callback) => {
        netPost('/api/auth/members', data)
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( typeof callback === 'function' ) {
                            callback();
                        }
                    }
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }

    const deleteMembers = (data, callback) => {
        netPost('/api/auth/delmembers',data)
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( typeof callback === 'function' ) {
                            callback();
                        }
                    }
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            if ( Array.isArray(roleModList) && roleModList.length > 0 ) {
                const amods = [];
                const dmods = [];
                roleModList.forEach( role => {
                    const arlist = addedRoleMembers[role];
                    if ( Array.isArray(arlist) ) {
                        arlist.forEach( member => {
                            amods.push({
                                role: role,
                                userId: member,
                                docId: selectedDocId
                            });
                        });
                    }
                    const drlist = deletedRoleMembers[role];
                    if ( Array.isArray(drlist) ) {
                        drlist.forEach( member => {
                            dmods.push({
                                role: role,
                                userId: member,
                                docId: selectedDocId,
                            });
                        })
                    }
                });
                if ( amods.length > 0 ) {
                    addMembers(amods);
                }
                if ( dmods.length > 0 ) {
                    deleteMembers(dmods);
                }
            }
            onSave({
                roles: roles, // roles processed (used in this workflow)
                roleMemberMap: roleMemberMap, // roles that were viewed and possibly modified from database values
            });
            
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onMemberValueChanged = (event) => {
        setMemberValue(event.target.value);
        setOkEnabled(true);
    };


    return (
        <Dialog
            maxWidth={'1100px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 900,
                        maxHeight: 800,
                        minHeight: 600,
                    }
                }
            }}
            
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{`${title}`}</DialogTitle>
            <DialogContent>
                <Box sx={{ height: '500px', width: '100%', display: 'grid', gridTemplateColumns: '30% 3px 4fr', gridTemplateRows: '100%', position: 'relative' }}>
                    <Box sx={{ position: 'relative', width: '100%', height: '100%', padding: '1ex', paddingTop: 0, display: 'grid', gridTemplateRows: 'min-content minmax(10px,1fr) min-content' }}>
                        <Box
                            sx={{ position: 'relative', minHeight: '2em', overflowY: 'auto', paddingTop: 0 }}

                        >
                            <Typography sx={{fontWeight: 'bold', pt: '1.2ex', pb: 2, fontSize: '0.92rem'}}>Role</Typography>
                            <SimpleTreeView onItemClick={handleItemClick} expansionTrigger="iconContainer">
                                {Array.isArray(roleList) && roleList.filter(r => r.type === 'V' && Array.isArray(roles) && roles.includes(r.name)).map((r, index) =>
                                    <TreeItem itemId={r.name} key={`${r.name}-${index}`}
                                        label={<Typography>{r.name}</Typography>}
                                        selected={selectedItemId === r.name} />
                                )}

                            </SimpleTreeView>

                        </Box>
                    </Box>

                    <Divider orientation="vertical" />

                    <Box sx={{ position: 'relative', height: '100%', }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%'  }}>

                            <Box sx={{ overflowY: 'auto', paddingTop: 0, flexGrow: 1 }} onContextMenu={(event) => handleContextMenu(event, -1)}>
                                <TableContainer component={Paper} sx={{ paddingTop: 0, height: '100%'}}>
                                    <Table sx={{ minWidth: 150 }} size="small" aria-label="member table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 'bold' }}>Member</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {selectedRole && roleMemberMap && Array.isArray(roleMemberMap[selectedRole]) &&
                                                selectedItem?.type === 'V' &&
                                                roleMemberMap[selectedRole].map((entry, index) => (
                                                    <TableRow selected={selectedIndex === index}
                                                        onClick={() => handleRowClick(index, entry)}
                                                        key={`USR-00-${index}`}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                        onContextMenu={(event) => handleContextMenu(event, index, entry)}
                                                    >
                                                        <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.userId}</TableCell>
                                                        <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.email}</TableCell>

                                                    </TableRow>
                                                ))

                                            }
                                            {selectedRole && selectedDoc && roleMemberMap && Array.isArray(roleMemberMap[selectedRole + '_' + selectedDoc]) &&
                                                selectedItem?.type === 'V' &&
                                                roleMemberMap[selectedRole + '_' + selectedDoc].map((entry, index) => (
                                                    <TableRow selected={selectedIndex === index}
                                                        onClick={() => handleRowClick(index, entry)}
                                                        key={`USR-00-${index}`}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                        onContextMenu={(event) => handleContextMenu(event, index, entry)}
                                                    >
                                                        <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.userId}</TableCell>
                                                        <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.email}</TableCell>

                                                    </TableRow>
                                                ))

                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Menu
                                    open={contextMenu !== null}
                                    onClose={handleContextMenuClose}
                                    anchorReference="anchorPosition"
                                    anchorPosition={
                                        contextMenu !== null
                                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                            : undefined
                                    }
                                >
                                    <MenuItem onClick={handleMemberAdd} >Add Member</MenuItem>
                                    <MenuItem onClick={handleMemberRemove} disabled={!deleteEnabled}>Delete Member</MenuItem>
                                </Menu>
                            </Box>
                            <Box sx={{ padding: '1ex', pb: 0, whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                                <Tooltip title="Add Member">
                                    <span>
                                        <IconButton color="inherit" onClick={handleMemberAdd} >
                                            <PersonAddIcon color="inherit" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip title="Delete Member">
                                    <span>
                                        <IconButton color="inherit" sx={{ marginLeft: '1em' }} disabled={!deleteEnabled} onClick={handleMemberRemove} >
                                            <PersonRemoveIcon color="inherit" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Box>
                            {/* <AddACEDialog open={addAceOpen} onCancel={() => {setAddAceOpen(false)}} path={selectedItemId} onSave={onAddSave} /> */}
                            <AddMultiMemberDialog open={addMemberOpen} onCancel={() => setAddMemberOpen(false)}
                                role={selectedItemId} onSave={onAddMemberSave} />
                        </Box>
                    </Box>

                </Box>

            </DialogContent>
            <DialogActions sx={{padding: 3, pt: 0}}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

const EditRoleMembersDialog = (props) => {
        const {
            title = 'Edit Role Members',
            open,
            onSave,
            onCancel,
            selectedRole,
            ...other
        } = props;

        const [selectedIndex, setSelectedIndex] = useState(-1);
        const [selectedMember, setSelectedMember] = useState(null);
        const [addMemberEnabled, setAddMemberEnabled] = useState(false);
        const [deleteEnabled, setDeleteEnabled] = useState(false);
        const [memberContextMenu, setMemberContextMenu] = useState(null);
        const [addedRoleMembers, setAddedRoleMembers] = useState({});
        const [deletedRoleMembers, setDeletedRoleMembers] = useState({});
        const [roleModList, setRoleModList] = useState([]);
        const [roleMemberMap, setRoleMemberMap] = useState({});
        const [selectedItemId, setSelectedItemId] = useState('');
        const [okEnabled, setOkEnabled] = useState(false);
        const [editOkEnabled, setEditOkEnabled] = useState(false);
        const [addMemberOpen, setAddMemberOpen] = useState(false);

        const theme = useTheme();
        

        useEffect(() => {
            if ( open ) {
                setDeleteEnabled(false);
                setAddMemberEnabled(true);
            }
        },[open]);

        const onEditOkClick = () => {
            if (typeof onSave === 'function') {
                onSave();
            }
        };

        const onEditCancelClick = () => {
            onEditClose();
        };

        const onEditClose = () => {
            if (typeof onCancel === 'function') {
                onCancel();
            }
        };

        const handleMemberRowClick = (index, entry) => {
            setSelectedIndex(index);
            setSelectedMember(entry);
            if (index >= 0) {
                setDeleteEnabled(true);

            } else {
                setDeleteEnabled(false);
            }
        };

        const handleMemberContextMenu = (event, index, user) => {
            event.preventDefault();
            setMemberContextMenu(
                memberContextMenu === null
                    ? {
                        mouseX: event.clientX + 2,
                        mouseY: event.clientY - 6,
                    }
                    : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                    // Other native context menus might behave different.
                    // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                    null,
            );
            if (index >= 0) {
                handleMemberRowClick(index, user);
            }

        }

        const handleMemberContextMenuClose = () => {
            setMemberContextMenu(null);
        };

        const handleMemberAdd = () => {

        };

        const onAddMemberSave = () => {

        };

        const handleMemberRemove = () => {
            handleMemberContextMenuClose();
            const userId = selectedMember?.userId;
            const added = { ...addedRoleMembers };
            const alist = added[selectedItemId];
            let mod = false;
            if (alist) {
                const m = alist.findIndex(r => r === userId);
                if (m >= 0) {
                    alist.splice(m, 1);
                    added[selectedItemId] = alist;
                    setAddedRoleMembers(added);
                }
            }
            const removed = { ...deletedRoleMembers };
            let rlist = removed[selectedItemId];
            if (!Array.isArray(rlist)) {
                rlist = [];
            }
            if (!rlist.includes(userId)) {
                rlist.push(userId);
                removed[selectedItemId] = rlist;
                setDeletedRoleMembers(removed);
                mod = true;
            }
            if (mod && !roleModList.includes(selectedItemId)) {
                const rml = [...roleModList];
                rml.push(selectedItemId);
                setRoleModList(rml);
            }
            const rmm = { ...roleMemberMap };
            const rmlist = rmm[selectedItemId];
            if (Array.isArray(rmlist)) {
                const r = rmlist.findIndex(u => u.userId === userId);
                if (r >= 0) {
                    rmlist.splice(r, 1);
                    rmm[selectedItemId] = rmlist;
                    setRoleMemberMap(rmm);
                }
            }
            setOkEnabled(true);
            /*
            netPost('/api/auth/delmember', {role: selectedItemId, userId: selectedMember?.userId, docId: selectedDocId})
                .then(response => {
                        if (!response.ok) {
                            throw new Error('Status: ' + response.status);
                        } 
                       setOkEnabled(true);
                       handleItemClick(null, selectedItemId);
                    })
                    .catch(error => {
                        console.log('Error: ' + error);
                    });
            */
        };

        return (
            <Dialog
                maxWidth={'1100px'}
                open={open}
                onClose={onEditClose}
                slotProps={{
                    paper: {
                        sx: {
                            minWidth: 900,
                            maxHeight: 800,
                            minHeight: 600,
                        }
                    }
                }}

            >
                <DialogTitle sx={{ fontWeight: 'bold' }}>{`Edit Role Members`}</DialogTitle>
                <DialogContent sx={{height: 500}}>
                    <Box sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                        <Box sx={{mb: 2, mt: 4}}>
                            <Typography sx={{display: 'inline-block', width: '8em', fontWeight: 'bold'}}>Role:</Typography>
                            <Typography sx={{display: 'inline-block',  fontSize: '105%', }}>{selectedRole}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', overflowY: 'auto', paddingTop: 0, flexGrow: 1 }} onContextMenu={(event) => handleMemberContextMenu(event, -1)}>
                            <Box sx={{width: '8em'}}>
                                <Typography sx={{fontWeight: 'bold', pt: 1}}>Members:</Typography>
                            </Box>
                            <TableContainer  sx={{ paddingTop: 0, height: '100%', border: 'none' }}>
                                <Table sx={{ minWidth: 150 }} size="small" aria-label="member table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }}>User ID</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold'}}>Email</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedRole && roleMemberMap && Array.isArray(roleMemberMap[selectedRole]) &&
                                            roleMemberMap[selectedRole].map((entry, index) => (
                                                <TableRow selected={selectedIndex === index}
                                                    onClick={() => handleMemberRowClick(index, entry)}
                                                    key={`USR-00-${index}`}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                    onContextMenu={(event) => handleMemberContextMenu(event, index, entry)}
                                                >
                                                    <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.userId}</TableCell>
                                                    <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{`${entry.givenName} ${entry.familyName}`}</TableCell>
                                                    <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.email}</TableCell>

                                                </TableRow>
                                            ))

                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Menu
                                open={memberContextMenu !== null}
                                onClose={handleMemberContextMenuClose}
                                anchorReference="anchorPosition"
                                anchorPosition={
                                    memberContextMenu !== null
                                        ? { top: memberContextMenu.mouseY, left: memberContextMenu.mouseX }
                                        : undefined
                                }
                            >
                                <MenuItem onClick={handleMemberAdd} >Add Member</MenuItem>
                                <MenuItem onClick={handleMemberRemove} disabled={!deleteEnabled}>Delete Member</MenuItem>
                            </Menu>
                        </Box>
                        <Box sx={{ padding: '7.5em', pb: 0, whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                            <Tooltip title="Add Member">
                                <span>
                                    <IconButton color="inherit" onClick={handleMemberAdd} >
                                        <PersonAddIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Delete Member">
                                <span>
                                    <IconButton color="inherit" sx={{ marginLeft: '1em' }} disabled={!deleteEnabled} onClick={handleMemberRemove} >
                                        <PersonRemoveIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                        {/* <AddACEDialog open={addAceOpen} onCancel={() => {setAddAceOpen(false)}} path={selectedItemId} onSave={onAddSave} /> */}
                        <AddMemberDialog open={addMemberOpen} onCancel={() => setAddMemberOpen(false)}
                            role={selectedItemId} onSave={onAddMemberSave} />
                    </Box>

                </DialogContent>
                <DialogActions sx={{padding: 3, pt: 0}}>
                    <Button variant="outlined" onClick={onEditOkClick} sx={{ minWidth: '7em' }} disabled={!editOkEnabled}>OK</Button>
                    <Button variant="outlined" onClick={onEditCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
                </DialogActions>
            </Dialog>
        );

    };

function RoleMemberDialog(props) {
    const {
        title = 'Role Configuration',
        open,
        onSave,
        onCancel,
        roles,
        memberMap,
        docId,
        ...other
    } = props;

    const [memberValue, setMemberValue] = useState(null);
    const [userList, setUserList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [roleMap, setRoleMap] = useState({});
    const [roleMemberMap, setRoleMemberMap] = useState({});
    const [addedRoleMembers, setAddedRoleMembers] = useState({});
    const [deletedRoleMembers, setDeletedRoleMembers] = useState({});
    const [roleModList, setRoleModList] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);
    const [addMemberOpen, setAddMemberOpen] = useState(false);
    const [addRoleOpen, setAddRoleOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedMember, setSelectedMember] = useState(null);

    const [addMemberEnabled, setAddMemberEnabled] = useState(false);
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState('ALL');
    const [selectedDoc, setSelectedDoc] = useState(null);
    
    const [contextMenu, setContextMenu] = useState(null);
    
    const [roleEditEnabled, setRoleEditEnabled] = useState(false);
    const [memberContextMenu, setMemberContextMenu] = useState(false);
    const [editRoleDialogOpen, setEditRoleDialogOpen] = useState(false);
    const [addRoleMembers, setAddRoleMembers] = useState([]);

    const theme = useTheme();

    useEffect(() => {
        setAddMemberEnabled(false);
        setDeleteEnabled(false);
        if ( open) {
            // setRoleEditEnabled(false);
            setSelectedItemId('');
            setSelectedRole(null);
            setSelectedMember(null);
            setRoleModList([]);
            setAddedRoleMembers({});
            setDeletedRoleMembers({});
            setEditRoleDialogOpen(false);
            if ( memberMap ) {
                setRoleMemberMap(memberMap);
            } else {
                setRoleMemberMap({});
            }
            if ( docId ) {
                if ( docId === 'NONE' ) {
                    setSelectedDocId('ALL');
                } else {
                    setSelectedDocId(docId);
                }
                loadRoles(docId);
            } else {
                setSelectedDocId('ALL');
                loadRoles('ALL');
            }
            netGet('/api/auth/users')
                .then(response => response.json())
                .then(users => {
                    if (Array.isArray(users)) {
                        setUserList(users);
                    }
                }).catch(error => {
                    console.log('Error fetching user list: ' + error);
                });
            
        } else {
            setEditRoleDialogOpen(false);
            setUserList([]);
            setMemberValue(null);
            setSelectedDocId('ALL');
            setSelectedDoc(null);
            setRoleModList([]);
            setAddedRoleMembers({});
            setDeletedRoleMembers({});
            setRoleMemberMap({});
            setSelectedRole(null);
            setSelectedMember(null);
            // setRoleEditEnabled(false);
        }
        
    }, [open, docId, memberMap, roles]);

    const loadRoles = (docName) => {
        setRoleMap({});
        netGet('/api/auth/aroles?g=0&v=1')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    // console.log('roles: ' + JSON.stringify(data));

                    setRoleList(data);
                    const rm = {};
                    data.forEach(r => {
                        rm[r.name] = r;
                    });
                    setRoleMap(rm);
                    /*
                    if ( !memberMap && Array.isArray(roles)) {
                        const rmm = {};
                        roles.forEach( rname => {
                            const role = rm[rname];
                            if ( role ) {
                                const members = role.members;
                                if ( members ) {
                                    const rmembers = members[docName];
                                    if ( rmembers)
                                }
                            }
                        })

                    }
                    */
                    if (Array.isArray(roles)) {
                        roles.reduce((promiseChain, role) => {
                            return promiseChain.then(accumulatedResults => {
                                return netGet('/api/auth/members?role=' + encodeURIComponent(role) + '&doc=' + encodeURIComponent(docName))
                                    .then(response => {
                                        if (!response.ok) {
                                            throw new Error('Status: ' + response.status);
                                        }
                                        return response.json();
                                    })
                                    .then(data => {
                                        const item = { role: role, members:[]};
                                        if (Array.isArray(data)) {
                                            // console.log('Members: ' + role + ' = ' + JSON.stringify(data))
                                            data.forEach( user => {
                                                const u = {...user};
                                                if ( user.firstName ) {
                                                    u.givenName = user.firstName;
                                                }
                                                if ( user.lastName ) {
                                                    u.familyName = user.lastName;
                                                }
                                                item.members.push(u);
                                            });
                                            /*
                                            const rmm = { ...roleMemberMap };
                                            rmm[role] = data;
                                            setRoleMemberMap(rmm);
                                            */
                                            // setSelectedRole(itemId);
                                        }
                                        return [...accumulatedResults, item];
                                    }).catch(error => {
                                        console.log('Error: ' + error);
                                    });
                            });
                        }, Promise.resolve([])).then(allResults => {
                            // console.log('All role members retrieved: ' + JSON.stringify(allResults));
                            if ( Array.isArray(allResults)) {
                                const rmm = { ...roleMemberMap };
                                allResults.forEach( item => {
                                    rmm[item.role] = item.members;
                                });
                                setRoleMemberMap(rmm);
                            }
                        });
                    }
                } else {
                    setRoleList([]);
                    setRoleMap({});

                }
            }).catch(error => {
                console.log('Error: ' + error);
                setRoleList([]);
                setRoleMap({});
            });
    }

    const handleRowClick = (index, role) => {
        // setSelectedIndex(index);
        setSelectedRole(role);
        setAddMemberEnabled( role ? true : false);
        setDeleteEnabled(false);
        setSelectedMember(null);
        // setRoleEditEnabled( role ? true : false);
        /*
        setSelectedMember(entry);
        if ( index >= 0 ) {
            setDeleteEnabled(true);

        } else {
            setDeleteEnabled(false);
        }
        */
    };

    const handleMemberClick = (role, user) => {
        setSelectedRole(role);
        setSelectedMember(user);
        setAddMemberEnabled( role ? true : false);
        setDeleteEnabled(role && user ? true : false);
    };

    const handleContextMenu = (event, index, role, user) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
        if ( user && role) {
            handleMemberClick(role, user);
            // console.log('MEMBER CLICK...')
            event.stopPropagation();
        } else if ( role) {
            handleRowClick(index,role);
            // console.log('ROLE CLICK...')
        }
    };

    const handleContextMenuClose = (event) => {
        setContextMenu(null);
    };

    const handleMemberAdd = () => {
        handleContextMenuClose();
        setAddMemberOpen(true);
        if ( selectedRole ) {
            const rms = roleMemberMap[selectedRole];
            setAddRoleMembers(rms);
            console.log('SET MEMBERS: ' + JSON.stringify(rms));
        } else {
            setAddRoleMembers([]);
            console.log('SET MEMBERS: []');
        }
    }

    const onAddMemberSave = (entry) => {
        handleContextMenuClose();
        setAddMemberOpen(false); 
        // console.log('ADD MEMBERS: ' + JSON.stringify(entry));
        const userId = entry.userId;
        const added = {...addedRoleMembers};
        const removed = { ...deletedRoleMembers };
        let alist = added[entry.role];
        if (!Array.isArray(alist)) {
            alist = [];
        }
        let rlist = removed[entry.role];
        if ( !Array.isArray(rlist) ) {
            rlist = [];
        }
        let mod = false;
        const rml = [...roleModList];
        const rmm = { ...roleMemberMap };
        let rmlist = rmm[entry.role]; 

        if (Array.isArray(entry.members)) {
            entry.members.forEach(member => {
                const userId = member.userId;

                if (!alist.includes(userId)) {
                    alist.push(userId);
                    added[entry.role] = alist;
                    // setAddedRoleMembers(added);
                    mod = true;
                }
                if (Array.isArray(rlist)) {
                    const r = rlist.findIndex(r => r === userId);
                    if (r >= 0) {
                        rlist.splice(r, 1);
                        removed[entry.role] = rlist;
                        // setDeletedRoleMembers(removed);
                    }
                } else {
                    rlist = [];
                }

                if (mod && !rml.includes(entry.role)) {
                    rml.push(entry.role);
                    // setRoleModList(rml);
                }
                
                if (Array.isArray(rmlist)) {
                    const au = rmlist.find(u => u.userId === userId);
                    if (!au) {
                        const user = userList.find(u => u.userId === userId);
                        if (user) {
                            const u = { ...user };
                            if (u.firstName) {
                                u.givenName = u.firstName;
                            }
                            if (u.lastName) {
                                u.familyName = u.lastName;
                            }
                            rmlist.push(u);
                            rmm[entry.role] = rmlist;
                            // setRoleMemberMap(rmm);
                        }
                    }
                } else {
                    const user = userList.find(u => u.userId === userId);
                    if (user) {
                        const u = { ...user };
                        if (u.firstName) {
                            u.givenName = u.firstName;
                        }
                        if (u.lastName) {
                            u.familyName = u.lastName;
                        }
                        rmlist = [u];
                        rmm[entry.role] = rmlist;
                        // setRoleMemberMap(rmm);
                    }
                }
                
            });
            if ( Array.isArray(rmlist) ) {
                const rmtarget = [...rmlist];
                let rmod = false;
                rmlist.forEach( m => {
                    const target = entry.members.find(u => u.userId === m.userId);
                    if ( !target ) {
                        // this item was deleted
                        console.log('REMOVING ' + m.userId);
                        const i = rmtarget.findIndex(u => u.userId === m.userId);
                        if ( i >= 0 ) {
                            rmtarget.splice(i, 1);
                            rmod = true;
                        }
                        // remove it from 'added'
                        if (Array.isArray(alist)) {
                            const a = alist.findIndex(uid => uid === m.userId);
                            if (a >= 0) {
                                alist.splice(a, 1);
                                added[entry.role] = alist;
                            }
                        }
                        // add it to 'removed'
                        if (Array.isArray(rlist)) {
                            const r = rlist.find(uid => uid === m.userId);
                            if (!r) {
                                rlist.push(m.userId);
                                removed[entry.role] = rlist;
                            }
                        } else {
                            rlist = [];
                            rlist.push(m.userId);
                            removed[entry.role] = rlist;
                        }
                    }
                });
                if ( rmod ) {
                    mod = true;
                    rmm[entry.role] = rmtarget;
                    console.log('New members: ' + JSON.stringify(rmtarget));
                    console.log('Added: ' + JSON.stringify(alist));
                    console.log('Removed: ' + JSON.stringify(rlist) );
                    console.log('Mod role list: ' + JSON.stringify(rml));
                    if (!rml.includes(entry.role) ) {
                        rml.push(entry.role);
                    }
                }
            }
            setOkEnabled(true);
            if ( mod ) {
                setAddedRoleMembers(added);
                setDeletedRoleMembers(removed);
                setRoleModList(rml);
                setRoleMemberMap(rmm);
            }
        }
        
    };

    const handleMemberRemove = () => {
            handleContextMenuClose();
            if ( !selectedRole || !selectedMember) {
                return;
            }
            const userId = selectedMember?.userId;
            const added = { ...addedRoleMembers };
            const alist = added[selectedRole];
            let mod = false;
            if (alist) {
                const m = alist.findIndex(r => r === userId);
                if (m >= 0) {
                    alist.splice(m, 1);
                    added[selectedRole] = alist;
                    setAddedRoleMembers(added);
                }
            }
            const removed = { ...deletedRoleMembers };
            let rlist = removed[selectedRole];
            if (!Array.isArray(rlist)) {
                rlist = [];
            }
            if (!rlist.includes(userId)) {
                rlist.push(userId);
                removed[selectedRole] = rlist;
                setDeletedRoleMembers(removed);
                mod = true;
            }
            if (mod && !roleModList.includes(selectedRole)) {
                const rml = [...roleModList];
                rml.push(selectedRole);
                setRoleModList(rml);
            }
            const rmm = { ...roleMemberMap };
            const rmlist = rmm[selectedRole];
            if (Array.isArray(rmlist)) {
                const r = rmlist.findIndex(u => u.userId === userId);
                if (r >= 0) {
                    rmlist.splice(r, 1);
                    rmm[selectedRole] = rmlist;
                    setRoleMemberMap(rmm);
                }
            }
            setOkEnabled(true);
            
        }

    

    const addMembers = (data, callback) => {
        return netPost('/api/auth/members', data)
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( typeof callback === 'function' ) {
                            callback();
                        }
                        console.log('Added role member: ' + JSON.stringify(data));
                    }
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }

    const deleteMembers = (data, callback) => {
        return netPost('/api/auth/delmembers',data)
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( typeof callback === 'function' ) {
                            callback();
                        }
                        console.log('Deleted role member: ' + JSON.stringify(data));
                    }
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            if ( Array.isArray(roleModList) && roleModList.length > 0 ) {
                const amods = [];
                const dmods = [];
                roleModList.forEach( role => {
                    const arlist = addedRoleMembers[role];
                    if ( Array.isArray(arlist) ) {
                        arlist.forEach( member => {
                            amods.push({
                                role: role,
                                userId: member,
                                docId: selectedDocId
                            });
                        });
                    }
                    const drlist = deletedRoleMembers[role];
                    if ( Array.isArray(drlist) ) {
                        drlist.forEach( member => {
                            dmods.push({
                                role: role,
                                userId: member,
                                docId: selectedDocId,
                            });
                        })
                    }
                });
                if ( amods.length > 0 ) {
                    addMembers(amods).then( result => {
                        deleteMembers(dmods);
                    });
                } else if ( dmods.length > 0 ) {
                    deleteMembers(dmods);
                }
            }
            onSave({
                roles: roles, // roles processed (used in this workflow)
                roleMemberMap: roleMemberMap, // roles that were viewed and possibly modified from database values
            });
            
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    return (
        <Dialog
            maxWidth={'1100px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 900,
                        maxWidth: 900,
                        maxHeight: 600,
                        minHeight: 600,
                    }
                }
            }}
            
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{`${title}`}</DialogTitle>
            <DialogContent>

                <Box sx={{ position: 'relative', height: '100%', }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>

                        <Box sx={{ overflowY: 'auto', paddingTop: 0, flexGrow: 1 }} onContextMenu={(event) => handleContextMenu(event, -1)}>
                            <TableContainer component={Paper} sx={{ paddingTop: 0, height: '100%' }}>
                                <Table sx={{ minWidth: 150 }} size="small" aria-label="member table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold', width: '30%' }}>Role</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', width: '70%' }}>Members</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Array.isArray(roleList) && roleList.filter(r => r.type === 'V' && Array.isArray(roles) && roles.includes(r.name)).map((r, index) =>
                                            <TableRow 
                                                
                                                key={`VRUSR-00-${index}`}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                onContextMenu={(event) => handleContextMenu(event, index, r.name)}
                                            >
                                                <TableCell
                                                    onClick={() => handleRowClick(index, r.name)}
                                                    sx={{
                                                        backgroundColor: selectedRole === r.name ? 'action.selected' : 'inherit',
                                                        cursor: 'pointer',
                                                        width: '30%'
                                                    }}
                                                    onContextMenu={(event) => handleContextMenu(event, index, r.name)}
                                                    >
                                                    <Typography>{r.name}</Typography>
                                                </TableCell>
                                                <TableCell sx={{width: '70%'}}>
                                                    {roleMemberMap && Array.isArray(roleMemberMap[r.name]) &&
                                                        roleMemberMap[r.name]
                                                            .sort( (a,b) => {
                                                                let r = a?.givenName && b?.givenName ? a.givenName.localeCompare(b.givenName) : 0;
                                                                if ( r === 0 ) {
                                                                    r = a?.familyName && b?.familyName ? a.familyName.localeCompare(b.familyName) : 0;
                                                                }
                                                                if ( r === 0 ) {
                                                                    r = a?.userId && b?.userId ? a.userId.localeCompare(b.userId) : 0;
                                                                }
                                                                return r;
                                                            })
                                                            .reduce((members, user) => (
                                                            members === '' ? 
                                                            <Box 
                                                                sx={{
                                                                    display: 'inline-block',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: selectedRole === r.name && user?.userId === selectedMember?.userId ? 'action.selected' : 'inherit',
                                                                }}
                                                                onClick={() => handleMemberClick(r.name, user)}
                                                                onContextMenu={(event) => handleContextMenu(event, index, r.name, user)}
                                                            >
                                                                <Typography sx={{display: 'inline-block', fontSize: '98%'}}>{`${user.givenName} ${user.familyName}`}</Typography>
                                                                <Typography sx={{display: 'inline-block', fontSize: '98%', fontStyle: 'italic', ml: '0.9ex'}}>{`(${user.userId})`}</Typography>
                                                            </Box> : 
                                                                <React.Fragment>
                                                                    {members}
                                                                    <Typography sx={{ display: 'inline-block', fontSize: '98%', pr: '0.9ex' }}>{'\u2060,'}</Typography>
                                                                    <Box 
                                                                        sx={{ 
                                                                            display: 'inline-block',
                                                                            cursor: 'pointer',
                                                                            backgroundColor: selectedRole === r.name && user?.userId === selectedMember?.userId ? 'action.selected' : 'inherit',
                                                                         }}
                                                                         onClick={() => handleMemberClick(r.name, user)}
                                                                         onContextMenu={(event) => handleContextMenu(event, index, r.name, user)}
                                                                    >
                                                                        <Typography sx={{ display: 'inline-block', fontSize: '98%' }}>{` ${user.givenName} ${user.familyName}`}</Typography>
                                                                        <Typography sx={{ display: 'inline-block', fontSize: '98%', fontStyle: 'italic', ml: '0.9ex' }}>{`(${user.userId})`}</Typography>
                                                                    </Box>
                                                                </React.Fragment>
                                                        ), '')

                                                    }
                                                </TableCell>

                                            </TableRow>
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Menu
                                open={contextMenu !== null}
                                onClose={handleContextMenuClose}
                                anchorReference="anchorPosition"
                                anchorPosition={
                                    contextMenu !== null
                                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                        : undefined
                                }
                            >
                                <MenuItem onClick={handleMemberAdd} disabled={!addMemberEnabled} >Add Member</MenuItem>
                                <MenuItem onClick={handleMemberRemove} disabled={!deleteEnabled} >Delete Member</MenuItem>
                            </Menu>
                        </Box>
                        
                        {/* 
                        <EditRoleMembersDialog open={editRoleDialogOpen} onCancel={() => setEditRoleDialogOpen(false)} onSave={onEditRoleMembersSave} />
                        */}
                        {/* <AddACEDialog open={addAceOpen} onCancel={() => {setAddAceOpen(false)}} path={selectedItemId} onSave={onAddSave} /> */}

                        <AddMultiMemberDialog open={addMemberOpen} onCancel={() => setAddMemberOpen(false)} members={addRoleMembers}
                            role={selectedRole} onSave={onAddMemberSave} />
                    </Box>

                </Box>

            </DialogContent>
            <DialogActions sx={{padding: 3, mt: 2, pt: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ whiteSpace: 'nowrap', overflowX: 'hidden', pl: 1 }} color={theme.palette.primary.main}>
                    <Tooltip title="Add Member">
                        <span>
                            <IconButton color="inherit" onClick={handleMemberAdd} disabled={!addMemberEnabled} >
                                <PersonAddIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Delete Member">
                        <span>
                            <IconButton color="inherit" sx={{ marginLeft: 2 }} disabled={!deleteEnabled} onClick={handleMemberRemove} >
                                <PersonRemoveIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
                <Box>
                    <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', ml: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );

}

function AddRoleDialog(props) {
    const {
        title = 'Add Role',
        type = 'G',
        edit = false, // create a new role
        role, // in case edit = true
        description, // in case edit = true
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [roleValue, setRoleValue] = useState('');
    const [descValue, setDescValue] = useState('');
    const [typeValue, setTypeValue] = useState('G');
    const [okEnabled, setOkEnabled] = useState(false);
    const [roleList, setRoleList] = useState([]);

    useEffect(() => {
        setRoleValue('');
        setDescValue('');
        if ( open ) {
            if (type) {
                setTypeValue(type);
            } else {
                setTypeValue('G');
            }
            let url = '/api/auth/aroles';
            if ( type === 'V' ) {
                url += '?g=0&v=1&d=0';
            } else if ( type === 'D' ) {
                url += '?g=0&d=1&v=0';
            }
            netGet(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('roles: ' + JSON.stringify(data));
                        const rnames = data.map( r => r.name);
                        setRoleList(rnames);
                        
                    } else {
                        setRoleList([]);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                    setRoleList([]);
                });
        }
    }, [open, type]);

    useEffect(() => {
        
    }, [type]);

    useEffect(() => {
        if ( edit ) {
            setDescValue(description);
            setRoleValue(role);
        } else {
            setRoleValue('');
            setDescValue('');
        }
    },[edit,role,description]);


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                role: roleValue,
                description: descValue,
                type: typeValue,
            });
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onRoleValueChanged = (event) => {
        setRoleValue(event.target.value);
        setOkEnabled(event.target.value !== '' && !roleList.includes(event.target.value));
    };

    const onDescValueChanged = (event) => {
        setDescValue(event.target.value);
        if ( edit ) {
            setOkEnabled(roleValue !== '' );
        }
    }

    const handleTypeChange = (event) => {
        setTypeValue(event.target.value);
    };


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: 700,
                    maxHeight: 600
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{`${title}`}</DialogTitle>
            <DialogContent>

                <Box sx={{ paddingTop: '2ex' }}>
                    <TextField value={roleValue} onChange={onRoleValueChanged} size="small" fullWidth label="Name" />
                    <TextField value={descValue} onChange={onDescValueChanged} size="small" fullWidth multiline label="Description" rows={2} sx={{mt: 2}} />
                </Box>
                {/* 
                <FormControl sx={{paddingTop: 3}}>
                    <FormLabel id="type-radio-buttons-group-label">Type</FormLabel>
                    <RadioGroup sx={{paddingLeft: 4}}
                        aria-labelledby="type-radio-buttons-group-label"
                        value={typeValue}
                        onChange={handleTypeChange}
                        name="radio-buttons-group"
                    >
                        <FormControlLabel value="G" control={<Radio />} label="Global" />
                        <FormControlLabel value="V" control={<Radio />} label="Document" />
                    </RadioGroup>
                </FormControl>
                */}
            </DialogContent>
            <DialogActions sx={{padding: 3}}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function DeleteRoleDialog(props) {
    const {
        title = 'Delete Role',
        type = 'G',
        edit = true, // create a new role
        role, // in case edit = true
        description, // in case edit = true
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [roleValue, setRoleValue] = useState('');
    const [descValue, setDescValue] = useState('');
    const [typeValue, setTypeValue] = useState('G');
    const [okEnabled, setOkEnabled] = useState(false);
    // const [roleList, setRoleList] = useState([]);

    useEffect(() => {
        setRoleValue('');
        setDescValue('');
        if ( open ) {
            /*
            netGet('/api/auth/aroles')
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('roles: ' + JSON.stringify(data));
                        const rnames = data.map( r => r.name);
                        setRoleList(rnames);
                        
                    } else {
                        setRoleList([]);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                    setRoleList([]);
                });
            */
        }
    }, [open]);

    useEffect(() => {
        if (type) {
            setTypeValue(type);
        } else {
            setTypeValue('G');
        }
    }, [type]);

    useEffect(() => {
        if ( edit ) {
            setDescValue(description);
            setRoleValue(role);
        } else {
            setRoleValue('');
            setDescValue('');
        }
    },[edit,role,description]);


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                role: roleValue,
                description: descValue,
                type: typeValue,
            });
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onRoleValueChanged = (event) => {
        setRoleValue(event.target.value);
        // setOkEnabled(event.target.value !== '' && !roleList.includes(event.target.value));
    };

    const onDescValueChanged = (event) => {
        setDescValue(event.target.value);
    }

    const handleTypeChange = (event) => {
        setTypeValue(event.target.value);
    };


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: 700,
                    maxHeight: 600
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{`${title}`}</DialogTitle>
            <DialogContent>

                <Box sx={{ paddingTop: '2ex' }}>
                    <TextField value={roleValue} onChange={onRoleValueChanged} size="small" fullWidth label="Name" slotProps={{input: {readOnly: true}}} />
                    <TextField value={descValue} onChange={onDescValueChanged} size="small" fullWidth multiline label="Description" rows={2} sx={{mt: 2}} slotProps={{input: {readOnly: true}}} />
                </Box>
                {/* 
                <FormControl sx={{paddingTop: 3}}>
                    <FormLabel id="type-radio-buttons-group-label">Type</FormLabel>
                    <RadioGroup sx={{paddingLeft: 4}}
                        aria-labelledby="type-radio-buttons-group-label"
                        value={typeValue}
                        onChange={handleTypeChange}
                        name="radio-buttons-group"
                    >
                        <FormControlLabel value="G" control={<Radio />} label="Global" />
                        <FormControlLabel value="V" control={<Radio />} label="Document" />
                    </RadioGroup>
                </FormControl>
                */}
            </DialogContent>
            <DialogActions sx={{padding: 3}}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} disabled={!okEnabled} color="error">Delete</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function RolesConfigurationOld(props) {

    const {
        open,
        ...other
    } = props;

    const [roleList, setRoleList] = useState([]);
    const [roleMap, setRoleMap] = useState({});
    const [roleMemberMap, setRoleMemberMap] = useState({});
    const [docList, setDocList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState('');
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [modified, setModified] = useState([]);
    const [addMemberEnabled, setAddMemberEnabled] = useState(false);
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [deleteRoleEnabled, setDeleteRoleEnabled] = useState(false);
    const [contextMenu, setContextMenu] = useState(null);
    const [addMemberOpen, setAddMemberOpen] = useState(false);
    const [addRoleOpen, setAddRoleOpen] = useState(false);

    const theme = useTheme();

    useEffect( () => {
        
        if ( open ) {
            // console.log('OPEN ROLE Config...');
            setDeleteEnabled(false);
            loadRoles();
            netGet('/api/doc/roots')
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('docs: ' + JSON.stringify(data));
                        setDocList(data);
                    } else {
                        setDocList([]);

                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                    setDocList([]);
                });
            

        } else {
            // console.log('CLOSE ROLES Config...');
            setDocList([]);
        }
        

    }, [open]);

    const loadRoles = () => {
        setDeleteRoleEnabled(false);
        setRoleMap({});
        setSelectedDocId('');
        setSelectedIndex(-1);
        setSelectedItem(null);
        setSelectedItemId(null);
        setSelectedDocId(null);
        netGet('/api/auth/aroles')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    // console.log('roles: ' + JSON.stringify(data));

                    setRoleList(data);
                    const rm = {};
                    data.forEach(r => {
                        rm[r.name] = r;
                    });
                    setRoleMap(rm);
                } else {
                    setRoleList([]);
                    setRoleMap({});

                }
            }).catch(error => {
                console.log('Error: ' + error);
                setRoleList([]);
                setRoleMap({});
            });
    }


    const saveRequired = (index) => {
        return modified.includes(index);
    };

    const handleRowClick = (index, entry) => {
        setSelectedIndex(index);
        setSelectedMember(entry);
        if ( index >= 0 ) {
            setDeleteEnabled(true);

        } else {
            setDeleteEnabled(false);
        }
        /*
        setSelectedIndex(index);
        if ( index >= 0 && !entry.inherited ) {
            setDeleteEnabled(true)
            if ( index < aclMap[selectedItemId].length - 1 ) {
                setMoveDownEnabled(true);
            } else {
                setMoveDownEnabled(false);
            }
            if ( index > 0 ) {
                if ( Array.isArray(aclMap[selectedItemId]) && !aclMap[selectedItemId][index-1].inherited ) {
                    setMoveUpEnabled(true);
                } else {
                    setMoveUpEnabled(false);
                }
            } else {
                setMoveUpEnabled(false);
            }
        } else {
            setDeleteEnabled(false);
            setMoveDownEnabled(false);
            setMoveUpEnabled(false);
        }
        */
    };

    const handleContextMenu = (event, index, entry) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
        if ( index >= 0 ) {
            handleRowClick(index,entry);
        }
    };

    const handleContextMenuClose = (event) => {
        setContextMenu(null);
    };

    const handleItemClick = (event, itemId) => {
        setSelectedItemId(itemId);
        const item = roleMap[itemId];
        setSelectedItem(item);
        setSelectedRole(null);
        setSelectedIndex(-1);
        setDeleteEnabled(false);
        setSelectedDocId('');
        setSelectedDoc(null);
        setDeleteRoleEnabled(true);
        if ( item?.type === 'G') {
            setAddMemberEnabled(true);
        } else {
            setAddMemberEnabled(false);
        }
        netGet('/api/auth/members?role=' + encodeURIComponent(itemId))
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('Members: ' + itemId + ' = ' + JSON.stringify(data))
                        roleMemberMap[itemId] = data;
                        setSelectedRole(itemId);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                });
        
    };

    const handleDocItemClick = (event, docId) => {
        setSelectedDocId(docId);
        setAddMemberEnabled(true);
        netGet('/api/auth/members?role=' + encodeURIComponent(selectedItemId) + '&doc=' + encodeURIComponent(docId))
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('Members: ' + itemId + ' = ' + JSON.stringify(data))
                        roleMemberMap[selectedItemId + '_' + docId] = data;
                        setSelectedDoc(docId);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                });
    };

    const handleMemberAdd = () => {
        handleContextMenuClose();
        setAddMemberOpen(true);
    }

    const handleMemberRemove = () => {
        handleContextMenuClose();
        setSelectedDocId('');
        setSelectedDoc(null);
        netPost('/api/auth/delmember', {role: selectedItemId, userId: selectedMember?.userId, docId: selectedDocId})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( selectedItem?.type === 'G' ) {
                            handleItemClick(null, selectedItemId);
                        } else if ( selectedItem?.type === 'V') {
                            handleDocItemClick(null, selectedDocId);
                        }
                    }
                    
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }


    const handleMenuDelete = () => {
        handleContextMenuClose();
        /*
        const entry = aclMap[selectedItemId];
        if ( Array.isArray(entry) && selectedIndex >= 0 && selectedIndex < entry.length) {
            // console.log('TO DELETE: ' + selectedIndex);

            entry.splice(selectedIndex, 1);
            const req = {
                path: selectedItemId,
                acl: entry.filter( e => !e.inherited ),
            };
            req.acl.reverse();
            // console.log('AFTER DELETE: ' + JSON.stringify(req));

            netPost('/api/auth/acl/put', req)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    
                    if ( Array.isArray(data) ) {
                        const aclm = {...aclMap};
                        aclm[req.path] = data;
                        setAclMap(aclm);
                        // console.log(`ACL[${req.path}] = ` + JSON.stringify(data));
                        handleRowClick(-1);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                });

        }
        */
    };

    const handleRoleAdd = () => {
        handleContextMenuClose();
        setAddRoleOpen(true);
    };

    const handleRoleRemove = () => {
        handleContextMenuClose();
        const role = roleMap[selectedItemId];
        if ( role ) {
            netPost('/api/auth/delrole', {name: role.name, type: role.type})
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        loadRoles();
                    }
                    
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
        }
    };

    const onAddMemberSave = (entry) => {
        handleContextMenuClose();
        setAddMemberOpen(false); 
        setSelectedDocId('');
        setSelectedDoc(null);
        netPost('/api/auth/member', {role: entry.role, userId: entry.userId, docId: selectedDocId})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( selectedItem?.type === 'G' ) {
                            handleItemClick(null, selectedItemId);
                        } else if ( selectedItem?.type === 'V') {
                            handleDocItemClick(null, selectedDocId);
                        }
                    }
                    return response.json();
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    };

    const onAddRoleSave = (entry) => {
        handleContextMenuClose();
        setAddRoleOpen(false); 
        netPost('/api/auth/role', {name: entry.role, type: entry.type})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        loadRoles();
                    }
                    return response.json();
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }

    
    return (
        <Box sx={{ height: '100%', width: '100%', display: 'grid', gridTemplateColumns: '30% 3px 4fr 3px 5fr', gridTemplateRows: '100%' }}>
            <Box sx={{position: 'relative', width: '100%', height: '100%', padding: '1ex', paddingTop: '2ex', display: 'grid',  gridTemplateRows: 'min-content minmax(10px,1fr) min-content'}}>
                <Typography align="center" sx={{paddingTop: '8px', paddingBottom: '0px', fontSize: '18px', fontWeight: theme.typography.fontWeightBold }}>Roles</Typography>
                {/*<TextField
                    id="mwa-search"
                    type="search"
                    size="small"
                    InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                />*/}
                <Box 
                    sx={{ position: 'relative', minHeight: '2em', overflowY: 'auto', paddingTop: 2}} 
                    
                >
                    <SimpleTreeView onItemClick={handleItemClick} expansionTrigger="iconContainer">
                        {Array.isArray(roleList) && roleList.map( (r,index) => 
                            <TreeItem itemId={r.name} key={`${r.name}-${index}`} 
                            label={<Typography sx={{fontWeight: r?.type === 'G' ? 'normal' : 'bold', fontStyle: r?.type === 'V' ? 'italic' : 'normal'}}>{r.name}</Typography>} 
                            selected={selectedItemId === r.name} />
                        )}
                        
                    </SimpleTreeView>
                    
                </Box>
                <Box sx={{ padding: '1ex', whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                    <Tooltip title="Add Role">
                        <span>
                        <IconButton color="inherit" onClick={handleRoleAdd} >
                            <GroupAddIcon color="inherit" />
                        </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Delete Role">
                        <span>
                        <IconButton color="inherit"  sx={{ marginLeft: '1em' }} disabled={!deleteRoleEnabled} onClick={handleRoleRemove} >
                            <GroupRemoveIcon color="inherit" />
                        </IconButton>
                        </span>
                    </Tooltip>
                    <AddRoleDialog open={addRoleOpen} onCancel={() => setAddRoleOpen(false)}
                        onSave={onAddRoleSave} />
                </Box>
            </Box>

            {selectedItem?.type === 'V' &&
                <React.Fragment>
                    <Divider orientation="vertical" />

                    <Box sx={{ padding: '1ex', paddingTop: '2ex', height: '100%' }}>
                        <Typography align="center" sx={{ paddingTop: '8px', paddingBottom: '0px', fontSize: '18px', fontWeight: theme.typography.fontWeightBold }}>Documents</Typography>
                        <Box
                            sx={{ position: 'relative', minHeight: '2em', paddingTop: 2, overflow: 'auto', height: 'calc(100% - 40px)' }}

                        >
                            <SimpleTreeView onItemClick={handleDocItemClick} expansionTrigger="iconContainer" sx={{ overflow: 'auto' }}>
                                {Array.isArray(docList) && docList.map((d, index) =>
                                    <TreeItem itemId={d.id} key={`${d.id}-${index}`}
                                        label={d.title}
                                        selected={selectedDocId === d.id} />
                                )}

                            </SimpleTreeView>

                        </Box>

                    </Box>
                </React.Fragment>
            }
            

            <Divider orientation="vertical"/>
            
            <Box sx={{ position: 'relative',  height: '100%', paddingTop: '2ex'}}>
                
                <Typography align="center" sx={{ paddingTop: '8px', paddingBottom: '0px', fontSize: '18px', fontWeight: theme.typography.fontWeightBold }}>Members</Typography>

                <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 'calc(100% - 40px)'}}>

                    <Box sx={{overflowY: 'auto', paddingTop: 1 }} onContextMenu={(event) => handleContextMenu(event, -1)}>
                        <TableContainer component={Paper} sx={{ paddingTop: 2 }}>
                            <Table sx={{ minWidth: 150 }} size="small" aria-label="member table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Member</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedRole && roleMemberMap && Array.isArray(roleMemberMap[selectedRole]) &&
                                        selectedItem?.type === 'G' &&
                                        roleMemberMap[selectedRole].map((entry, index) => (
                                            <TableRow selected={selectedIndex === index}
                                                onClick={() => handleRowClick(index, entry)}
                                                key={`USR-00-${index}`}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                onContextMenu={(event) => handleContextMenu(event, index, entry)}
                                            >
                                                <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.userId}</TableCell>
                                                <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.email}</TableCell>

                                            </TableRow>
                                        ))

                                    }
                                    {selectedRole && selectedDoc && roleMemberMap && Array.isArray(roleMemberMap[selectedRole + '_' + selectedDoc]) &&
                                        selectedItem?.type === 'V' &&
                                        roleMemberMap[selectedRole + '_' + selectedDoc].map((entry, index) => (
                                            <TableRow selected={selectedIndex === index}
                                                onClick={() => handleRowClick(index, entry)}
                                                key={`USR-00-${index}`}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                onContextMenu={(event) => handleContextMenu(event, index, entry)}
                                            >
                                                <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.userId}</TableCell>
                                                <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.email}</TableCell>

                                            </TableRow>
                                        ))

                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Menu
                            open={contextMenu !== null}
                            onClose={handleContextMenuClose}
                            anchorReference="anchorPosition"
                            anchorPosition={
                                contextMenu !== null
                                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                    : undefined
                            }
                        >
                            <MenuItem onClick={handleMemberAdd} >Add Member</MenuItem>
                            <MenuItem onClick={handleMemberRemove} disabled={!deleteEnabled}>Delete Member</MenuItem>
                            {/*
                        <MenuItem onClick={handleMenuUp} disabled={!moveUpEnabled}>Move Up</MenuItem>
                        <MenuItem onClick={handleMenuDown} disabled={!moveDownEnabled}>Move Down</MenuItem>
                        */}
                        </Menu>
                    </Box>
                    <Box sx={{ padding: '1ex', whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                        <Tooltip title="Add Member">
                            <span>
                                <IconButton color="inherit" onClick={handleMemberAdd} >
                                    <PersonAddIcon color="inherit" />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Delete Member">
                            <span>
                                <IconButton color="inherit" sx={{ marginLeft: '1em' }} disabled={!deleteEnabled} onClick={handleMemberRemove} >
                                    <PersonRemoveIcon color="inherit" />
                                </IconButton>
                            </span>
                        </Tooltip>
                        {/* 
                    <Tooltip title="Move Up">
                        <span>
                        <IconButton color="inherit"  sx={{ marginLeft: '1em' }} disabled={!moveUpEnabled} onClick={handleMenuUp} >
                            <MoveUpIcon color="inherit" />
                        </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Move Down">
                        <span>
                        <IconButton color="inherit" disabled={!moveDownEnabled} onClick={handleMenuDown} >
                            <MoveDownIcon color="inherit" />
                        </IconButton>
                        </span>
                    </Tooltip>
                    */}
                    </Box>
                    {/* <AddACEDialog open={addAceOpen} onCancel={() => {setAddAceOpen(false)}} path={selectedItemId} onSave={onAddSave} /> */}
                    <AddMemberDialog open={addMemberOpen} onCancel={() => setAddMemberOpen(false)}
                        role={selectedItemId} onSave={onAddMemberSave} />
                </Box>
            </Box>

        </Box>

    );
}

function RolesConfiguration(props) {

    const {
        open,
        readOnly = false,
        ...other
    } = props;

    const [roleList, setRoleList] = useState([]);
    const [roleMap, setRoleMap] = useState({});
    const [roleMemberMap, setRoleMemberMap] = useState({});
    
    const [docList, setDocList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState('');
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [modified, setModified] = useState([]);
    const [addMemberEnabled, setAddMemberEnabled] = useState(false);
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [deleteRoleEnabled, setDeleteRoleEnabled] = useState(false);
    const [contextMenu, setContextMenu] = useState(null);
    const [addMemberOpen, setAddMemberOpen] = useState(false);
    const [addRoleOpen, setAddRoleOpen] = useState(false);
    const [editRoleOpen, setEditRoleOpen] = useState(false);
    const [editRole, setEditRole] = useState(null);
    const [tabValue, setTabValue] = useState('W');
    const [roleType, setRoleType] = useState('V'); // virtual, per document, per workflow

    const theme = useTheme();

    useEffect( () => {
        
        if ( open ) {
            // console.log('OPEN ROLE Config...');
            setDeleteEnabled(false);
            loadRoles();
            netGet('/api/doc/roots')
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('docs: ' + JSON.stringify(data));
                        setDocList(data);
                    } else {
                        setDocList([]);

                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                    setDocList([]);
                });
            

        } else {
            // console.log('CLOSE ROLES Config...');
            setDocList([]);
        }
        

    }, [open]);

    const loadRoles = () => {
        setDeleteRoleEnabled(false);
        setRoleMap({});
        setSelectedDocId('');
        setSelectedIndex(-1);
        setSelectedItem(null);
        setSelectedItemId(null);
        setSelectedDocId(null);
        netGet('/api/auth/aroles?v=1&d=1')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    console.log('roles: ' + JSON.stringify(data));

                    setRoleList(data);
                    const rm = {};
                    data.forEach(r => {
                        rm[`${r.type}-${r.name}`] = r;
                    });
                    setRoleMap(rm);
                } else {
                    setRoleList([]);
                    setRoleMap({});

                }
            }).catch(error => {
                console.log('Error: ' + error);
                setRoleList([]);
                setRoleMap({});
            });
    }


    const saveRequired = (index) => {
        return modified.includes(index);
    };

    const handleRowClick = (index, entry) => {
        setSelectedIndex(index);
        setSelectedMember(entry);
        if ( index >= 0 ) {
            setDeleteEnabled(true);

        } else {
            setDeleteEnabled(false);
        }
        
    };

    const handleContextMenu = (event, index, entry) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
        if ( index >= 0 ) {
            handleRowClick(index,entry);
        }
    };

    const handleContextMenuClose = (event) => {
        setContextMenu(null);
    };

    const handleItemClick = (event, itemId) => {
        setSelectedItemId(itemId);
        const item = roleMap[itemId];
        if (item) {
            setSelectedItem(item);
            setSelectedRole(null);
            setSelectedIndex(-1);
            setDeleteEnabled(false);
            setSelectedDocId('');
            setSelectedDoc(null);
            setDeleteRoleEnabled(true);
            if (item?.type === 'G') {
                setAddMemberEnabled(true);
            } else {
                setAddMemberEnabled(false);
            }
            netGet('/api/auth/members?type=' + item.type + '&role=' + encodeURIComponent(item.name))
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('Members: ' + itemId + ' = ' + JSON.stringify(data))
                        roleMemberMap[itemId] = data;
                        setSelectedRole(itemId);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                });
        }
    };

    const handleDocItemClick = (event, docId) => {
        setSelectedDocId(docId);
        setAddMemberEnabled(true);
        netGet('/api/auth/members?role=' + encodeURIComponent(selectedItemId) + '&doc=' + encodeURIComponent(docId))
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    if (Array.isArray(data)) {
                        // console.log('Members: ' + itemId + ' = ' + JSON.stringify(data))
                        roleMemberMap[selectedItemId + '_' + docId] = data;
                        setSelectedDoc(docId);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                });
    };

    const handleMemberAdd = () => {
        handleContextMenuClose();
        setAddMemberOpen(true);
    }

    const handleMemberRemove = () => {
        handleContextMenuClose();
        setSelectedDocId('');
        setSelectedDoc(null);
        netPost('/api/auth/delmember', {role: selectedItem.name, userId: selectedMember?.userId, docId: selectedDocId, type: roleType})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( selectedItem?.type === 'G' ) {
                            handleItemClick(null, selectedItemId);
                        } else if ( selectedItem?.type === 'V') {
                            handleDocItemClick(null, selectedDocId);
                        }
                    }
                    
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }

    


    const handleMenuDelete = () => {
        handleContextMenuClose();
        /*
        const entry = aclMap[selectedItemId];
        if ( Array.isArray(entry) && selectedIndex >= 0 && selectedIndex < entry.length) {
            // console.log('TO DELETE: ' + selectedIndex);

            entry.splice(selectedIndex, 1);
            const req = {
                path: selectedItemId,
                acl: entry.filter( e => !e.inherited ),
            };
            req.acl.reverse();
            // console.log('AFTER DELETE: ' + JSON.stringify(req));

            netPost('/api/auth/acl/put', req)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    
                    if ( Array.isArray(data) ) {
                        const aclm = {...aclMap};
                        aclm[req.path] = data;
                        setAclMap(aclm);
                        // console.log(`ACL[${req.path}] = ` + JSON.stringify(data));
                        handleRowClick(-1);
                    }
                }).catch(error => {
                    console.log('Error: ' + error);
                });

        }
        */
    };

    const handleRoleAdd = () => {
        handleContextMenuClose();
        setAddRoleOpen(true);
    };

    const handleRoleEdit = () => {
        handleContextMenuClose();
        if ( selectedItem ) {
            const item = {...selectedItem};
            setEditRole(item);
        } else {
            setEditRole(null);
        }
        setEditRoleOpen(true);

    }

    const handleRoleRemove = () => {
        handleContextMenuClose();
        const role = roleMap[selectedItemId];
        if ( role ) {
            netPost('/api/auth/delrole', {name: role.name, type: role.type})
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        loadRoles();
                    }
                    
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
        }
    };

    const onAddMemberSave = (entry) => {
        handleContextMenuClose();
        setAddMemberOpen(false); 
        setSelectedDocId('');
        setSelectedDoc(null);
        netPost('/api/auth/member', {role: entry.role, userId: entry.userId, docId: selectedDocId, type: roleType})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        if ( selectedItem?.type === 'G' ) {
                            handleItemClick(null, selectedItemId);
                        } else if ( selectedItem?.type === 'V') {
                            handleDocItemClick(null, selectedDocId);
                        }
                    }
                    return response.json();
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    };

    const onAddRoleSave = (entry) => {
        handleContextMenuClose();
        setAddRoleOpen(false); 
        netPost('/api/auth/role', {name: entry.role, description: entry.description, type: entry.type})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        loadRoles();
                    }
                    return response.json();
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
    }

    const onEditRoleSave = (entry) => {
        handleContextMenuClose();
        setEditRoleOpen(false);
        
        netPost('/api/auth/role', {name: entry.role, description: entry.description, type: entry.type, replace: selectedItem?.name})
            .then(response => {
                    if (!response.ok) {
                        throw new Error('Status: ' + response.status);
                    } else {
                        loadRoles();
                    }
                    return response.json();
                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
        
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setDeleteRoleEnabled(false);
        setDeleteEnabled(false);
        setSelectedItemId('');
        setSelectedItem(null);
        setAddMemberEnabled(false);
        switch(newValue) {
            case 'W':
                setRoleType('V');
                break;
            case 'D':
                setRoleType('D');
                break;
            case 'G':
                setRoleType('G');
                break;
        }
    };


    
    return (
        <Box sx={{width: '100%', height: '100%', padding: 2}}>
            <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange} aria-label="UCS Roles">
                        <Tab label="Workflow Roles" value="W" />
                        <Tab label="Document Roles" value="D" />
                        <Tab label="System Roles" value="G" />
                    </TabList>
                </Box>
                <TabPanel value="W" sx={{height: '100%', padding: '2px'}}>
                    <Box sx={{ position: 'relative', width: '100%', height: '100%', padding: 1, display: 'grid', gridTemplateRows: 'minmax(10px,1fr) min-content' }}>
                        {/*<TextField
                    id="mwa-search"
                    type="search"
                    size="small"
                    InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                />*/}
                        <Box
                            sx={{ position: 'relative', minHeight: '2em', overflow: 'auto'}}

                        >
                            <SimpleTreeView onItemClick={handleItemClick} expansionTrigger="iconContainer" >
                                {Array.isArray(roleList) && roleList.filter( r => r.type === 'V').map((r, index) =>
                                    <TreeItem itemId={`V-${r.name}`} key={`V-${r.name}-${index}`}
                                        label={<Typography>{r.name}</Typography>}
                                        selected={selectedItemId === `V-${r.name}`} />
                                )}

                            </SimpleTreeView>

                        </Box>
                        <Box sx={{ padding: 1, paddingBottom: 3, paddingTop: 0, whiteSpace: 'nowrap', overflowX: 'hidden', borderTop: 1, borderColor: 'divider'  }} color={theme.palette.primary.main}>
                            <Tooltip title="Add Role">
                                <span>
                                    <IconButton color="inherit" onClick={handleRoleAdd} disabled={readOnly} >
                                        <GroupAddIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Edit Role">
                                <span>
                                    <IconButton color="inherit" onClick={handleRoleEdit} disabled={readOnly || !deleteRoleEnabled} >
                                        <EditIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Delete Role">
                                <span>
                                    <IconButton color="inherit" sx={{ marginLeft: '1em' }} disabled={!deleteRoleEnabled || readOnly} onClick={handleRoleRemove} >
                                        <GroupRemoveIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            {/* 
                            <AddRoleDialog open={addRoleOpen} onCancel={() => setAddRoleOpen(false)}
                                type={roleType} onSave={onAddRoleSave} />
                            */}
                        </Box>
                    </Box>
                </TabPanel>
                <TabPanel value="D" sx={{height: '100%', padding: '2px'}}>
                    <Box sx={{ position: 'relative', width: '100%', height: '100%', padding: 1, display: 'grid', gridTemplateRows: 'minmax(10px,1fr) min-content' }}>
                        <Box
                            sx={{ position: 'relative', minHeight: '2em', overflow: 'auto'}}

                        >
                            <SimpleTreeView onItemClick={handleItemClick} expansionTrigger="iconContainer" >
                                {Array.isArray(roleList) && roleList.filter( r => r.type === 'D').map((r, index) =>
                                    <TreeItem itemId={`D-${r.name}`} key={`D-${r.name}-${index}`}
                                        label={<Typography>{r.name}</Typography>}
                                        selected={selectedItemId === `D-${r.name}`} />
                                )}

                            </SimpleTreeView>

                        </Box>
                        <Box sx={{ padding: 1, paddingBottom: 3, paddingTop: 0, whiteSpace: 'nowrap', overflowX: 'hidden', borderTop: 1, borderColor: 'divider'  }} color={theme.palette.primary.main}>
                            <Tooltip title="Add Role">
                                <span>
                                    <IconButton color="inherit" onClick={handleRoleAdd} disabled={readOnly} >
                                        <GroupAddIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Edit Role">
                                <span>
                                    <IconButton color="inherit" onClick={handleRoleEdit} disabled={readOnly || !deleteRoleEnabled} >
                                        <EditIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Delete Role">
                                <span>
                                    <IconButton color="inherit" sx={{ marginLeft: '1em' }} disabled={!deleteRoleEnabled || readOnly} onClick={handleRoleRemove} >
                                        <GroupRemoveIcon color="inherit" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            
                        </Box>
                    </Box>
                </TabPanel>
                <TabPanel value="G" sx={{height: '100%', padding: '2px'}}>
                    <Box sx={{ height: '100%', width: '100%', display: 'grid', gridTemplateColumns: '30% 3px 1fr', gridTemplateRows: '100%' }}>
                        <Box sx={{ position: 'relative', width: '100%', height: '100%', padding: '1ex', paddingTop: '2ex', display: 'grid', gridTemplateRows: 'min-content 1fr min-content' }}>
                            <Typography align="left" sx={{ paddingTop: '1.3ex', paddingBottom: 0, fontSize: '0.92rem', fontWeight: theme.typography.fontWeightBold }}>Role</Typography>

                            <Box
                                sx={{ position: 'relative', minHeight: '2em', overflowY: 'auto', paddingTop: 2 }}

                            >
                                <SimpleTreeView onItemClick={handleItemClick} expansionTrigger="iconContainer">
                                    {Array.isArray(roleList) && roleList.filter( r => r.type === 'G').map((r, index) =>
                                        <TreeItem itemId={`G-${r.name}`} key={`G-${r.name}-${index}`}
                                            label={<Typography sx={{ }}>{r.name}</Typography>}
                                            selected={selectedItemId === `G-${r.name}`} />
                                    )}

                                </SimpleTreeView>

                            </Box>
                            <Box sx={{ padding: 1, pb: 4, whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                                <Tooltip title="Add Role">
                                    <span>
                                        <IconButton color="inherit" onClick={handleRoleAdd} disabled={readOnly} >
                                            <GroupAddIcon color="inherit" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip title="Edit Role">
                                    <span>
                                        <IconButton color="inherit" onClick={handleRoleEdit} disabled={readOnly || !deleteRoleEnabled} >
                                            <EditIcon color="inherit" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip title="Delete Role">
                                    <span>
                                        <IconButton color="inherit" sx={{ marginLeft: '1em' }} disabled={!deleteRoleEnabled || readOnly} onClick={handleRoleRemove} >
                                            <GroupRemoveIcon color="inherit" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                
                            </Box>
                        </Box>

                        <Divider orientation="vertical" />

                        <Box sx={{ position: 'relative', height: '100%', }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', pb: '1ex' }}>

                                <Box sx={{ overflowY: 'auto', flexGrow: 1 }} onContextMenu={(event) => handleContextMenu(event, -1)}>
                                    <TableContainer component={Paper} sx={{ paddingTop: 2 }}>
                                        <Table sx={{ minWidth: 150 }} size="small" aria-label="member table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Member</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectedRole && roleMemberMap && Array.isArray(roleMemberMap[selectedRole]) &&
                                                    selectedItem?.type === 'G' &&
                                                    roleMemberMap[selectedRole].map((entry, index) => (
                                                        <TableRow selected={selectedIndex === index}
                                                            onClick={() => handleRowClick(index, entry)}
                                                            key={`USR-00-${index}`}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                            onContextMenu={(event) => handleContextMenu(event, index, entry)}
                                                        >
                                                            <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.userId}</TableCell>
                                                            <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.email}</TableCell>

                                                        </TableRow>
                                                    ))

                                                }
                                                {selectedRole && selectedDoc && roleMemberMap && Array.isArray(roleMemberMap[selectedRole + '_' + selectedDoc]) &&
                                                    selectedItem?.type === 'V' &&
                                                    roleMemberMap[selectedRole + '_' + selectedDoc].map((entry, index) => (
                                                        <TableRow selected={selectedIndex === index}
                                                            onClick={() => handleRowClick(index, entry)}
                                                            key={`USR-00-${index}`}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                                                            onContextMenu={(event) => handleContextMenu(event, index, entry)}
                                                        >
                                                            <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.userId}</TableCell>
                                                            <TableCell sx={{ color: entry.inherited ? 'gray' : 'black' }}>{entry.email}</TableCell>

                                                        </TableRow>
                                                    ))

                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Menu
                                        open={contextMenu !== null}
                                        onClose={handleContextMenuClose}
                                        anchorReference="anchorPosition"
                                        anchorPosition={
                                            contextMenu !== null
                                                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                                : undefined
                                        }
                                    >
                                        <MenuItem onClick={handleMemberAdd} >Add Member</MenuItem>
                                        <MenuItem onClick={handleMemberRemove} disabled={!deleteEnabled}>Delete Member</MenuItem>
                                        
                                    </Menu>
                                </Box>
                                <Box sx={{ padding: 1, pb: 4, whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                                    <Tooltip title="Add Member">
                                        <span>
                                            <IconButton color="inherit" onClick={handleMemberAdd} disabled={readOnly || !addMemberEnabled}>
                                                <PersonAddIcon color="inherit" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Delete Member">
                                        <span>
                                            <IconButton color="inherit" sx={{ marginLeft: '1em' }} disabled={!deleteEnabled || readOnly} onClick={handleMemberRemove} >
                                                <PersonRemoveIcon color="inherit" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    
                                </Box>
                                {/* <AddACEDialog open={addAceOpen} onCancel={() => {setAddAceOpen(false)}} path={selectedItemId} onSave={onAddSave} /> */}
                                <AddMemberDialog open={addMemberOpen} onCancel={() => setAddMemberOpen(false)}
                                    role={selectedItem?.name} onSave={onAddMemberSave} />
                            </Box>
                        </Box>

                    </Box>
                </TabPanel>
            </TabContext>
            <AddRoleDialog open={addRoleOpen} onCancel={() => setAddRoleOpen(false)}
                type={roleType} onSave={onAddRoleSave} />
            <AddRoleDialog open={editRoleOpen} onCancel={() => setEditRoleOpen(false)} title="Edit Role"
                type={roleType} onSave={onEditRoleSave} edit={true} role={editRole?.name} description={editRole?.description} />

        </Box>
    );
}

export { RolesConfiguration, RoleMemberDialog };